module.exports = __webpack_public_path__ + "static/media/JCB.1f9575f0.svg";